export default [
    {
        label: "Treningi",
        path: "/treningi"
    },
    {
        label: "Wiedza",
        path: "/blog/all"
    },
    {
        label: "Blog",
        path: "https://hpba.pl",
        newWindow: true
    },
    {
        label: "Kontakt",
        path: "/contact"
    },
    {
        label: 'Przejdź do diety',
        path: '/day-plan',
    }
];
